import { Stack, Typography } from '@mui/material'
import type { ReactNode } from 'react'

import { convertToRoundedMw } from '@/features/bidding/utils/calculations/convertToRoundedMw'

/** PTU mini-stat slot: total offered across all rendered Activation Groups. */
export function renderPtuMeta(offeredWatts: number): ReactNode {
  return <MetaLine bold label="OFF" valueMw={offeredWatts} />
}

/** Per-activation-group mini-stats slot: OBL (or "—" when unavailable) over OFF. */
export function renderActivationGroupMeta(
  obligationWatts: number,
  offeredWatts: number,
  obligationsAvailable: boolean,
): ReactNode {
  return (
    <Stack spacing={0.25}>
      {obligationsAvailable ? <MetaLine label="OBL" valueMw={obligationWatts} /> : <MetaLine unavailable label="OBL" />}
      <MetaLine label="OFF" valueMw={offeredWatts} />
    </Stack>
  )
}

type MetaLineProps = Readonly<{
  label: string
  valueMw?: number
  bold?: boolean
  /** When true, renders "—" instead of a number — used when the source data is unavailable. */
  unavailable?: boolean
}>

function MetaLine({ label, valueMw, bold, unavailable }: MetaLineProps) {
  return (
    <Stack direction="row" justifyContent="space-between" spacing={1}>
      <Typography color="text.secondary" variant="caption">
        {label}
      </Typography>
      <Typography color={unavailable ? 'text.disabled' : undefined} fontWeight={bold ? 600 : 400} variant="caption">
        {unavailable ? '—' : `${convertToRoundedMw(valueMw ?? 0).toFixed(1)} MW`}
      </Typography>
    </Stack>
  )
}
